import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { User } from '../types';
import { PATHS } from '../lib/paths';
import { Summary } from './Summary';

interface Props {
  user: User;
}

/* eslint-disable react/destructuring-assignment */
export function UserDetails({ user }: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleShareClick = () => {
    navigator.clipboard.writeText(`${import.meta.env.VITE_DOMAIN}${PATHS.userPath(user.id)}`);
    toast.success(t('common.copiedLink'));
  };

  const summaryComponent = () => (
    <span className="badge bg-neutral-200 font-medium text-label">{t(`user.${user.role}`)}</span>
  );

  return (
    <Summary title={user.name} summaryComponent={summaryComponent()}>
      <div className="grid grid-cols-[fit-content_auto] gap-5 pt-10 pb-3">
        <span className="font-semibold whitespace-nowrap">{t('project.createdAt')}</span>
        <span>{new Date(user.createdAt).toLocaleDateString()}</span>

        <span className="font-semibold">{t('common.email')}</span>
        <span>{user.email}</span>

        <div className="flex justify-end items-start gap-4 col-span-2">
          <button className="primary-outline" onClick={() => navigate(PATHS.userPath(user.id))}>
            <i className="ri-file-info-line" />
            {t('common.details')}
          </button>
          <button className="primary-outline whitespace-nowrap" onClick={handleShareClick}>
            <i className="ri-share-forward-line" />
            {t('common.copyLink')}
          </button>
        </div>
      </div>
    </Summary>
  );
}
